<template>
                <div class="newp">
                <div class="row row-offset-2 justify-content-sm-center">
                    <div class="col-md-10 col-lg-6 col-xl-4">
                    <h3>Reset your Password</h3>
                    <v-form ref="loginForm" v-model="valid" @submit.prevent="resetpassword()" class="rd-mailform rd-form text-left">
                        <div class="form-wrap">
                                <label class="form-label-outside" for="password">Password</label>
                                <!-- <v-text-field v-model="reset.password" class="form-input form-input-gray" id="password"
                                    type="password" :rules="passwordRules"></v-text-field> -->
                                     <v-text-field
                                        v-model="reset.password"
                                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="passwordRules"
                                        :type="show1 ? 'text' : 'password'"
                                        hint=""
                                        label=""
                                        name=""
                                        @click:append="show1 = !show1"
                                        class="form-input form-input-gray"
                                        id="password"
                                    ></v-text-field>

                            </div>
                            <div class="form-wrap">
                                <label class="form-label-outside" for="password">Confirm Password</label>
                                <!-- <v-text-field v-model="reset.rePassword" class="form-input form-input-gray" id="password"
                                    type="password" :rules="repassWord"></v-text-field> -->
                                    <v-text-field
                                        v-model="reset.rePassword"
                                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="repassWord"
                                        :type="show2     ? 'text' : 'password'"
                                        hint=""
                                        label=""
                                        name=""
                                        @click:append="show2 = !show2"
                                        class="form-input form-input-gray"
                                        id="password"
                                    ></v-text-field>
                            </div>
                    <button class="button button-primary button-block button-sm mb-5" type="submit">Submit</button>
                </v-form>
                </div>
                </div>
            </div>
</template>
<script>
// import registerCom from '@/components/registerCom.vue';
import axios from 'axios'
// import headerCom1 from "@/components/headerCom1.vue"; 

import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';

export default{
    data(){
        return{
            show1: false,
        show2: false,
        password1: '',
            portalId:"",
            reset:{
            password:"",
            rePassword:"",
            email:"",
            user_id:"",
        },
            newPasswordReq:{
                new_password:"",
                confirm_password :"",
                user_id:"",
                email:"",
                portalId:"",
                "request_type": "reset_password"
            },
            passwordRules: [
                v => !!v || 'Please enter your password',
                v => v.length >= 6 || 'Password must be at least 6 characters'
            ],
        };
    },
    computed: {
        repassWord() {
            return [
                v => !!v || 'Please enter your Re-password',
                v => v === this.reset.password || 'Passwords do not match'
            ];
        }
    },
    methods:{
        resetpassword(){
            this.newPasswordReq.new_password = this.reset.password
            this.newPasswordReq.confirm_password  = this.reset.rePassword
            this.newPasswordReq.email = this.email
            this.newPasswordReq.user_id = this.user_id
            this.newPasswordReq.portalId = this.portalId

            
            axios.post(this.newPasswordReqURL, this.newPasswordReq, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })

        },
        getConfig() {
          // let portalLocal = localStorage.getItem("portalData")
          // let getConfigData1 = JSON.parse(portalLocal)
          const getConfigData1 = getConfigDataFromLocalStorage();
          if (getConfigData1) {
              this.newPasswordReqURL = getConfigData1.payload.portal_configuration.API_endpoints.update_password
              this.portalId = getConfigData1.payload.portal_configuration.portal_id

          }
      },

    },

    created() {
        this.getConfig();
    },
    }
</script>
<style scoped>
ul {
    padding-left: 0px;
}

button{
    color: white;
}

.nav-custom {
    border: none;
}

:deep(.v-field__input) {
    background-color: white;
}

:deep(.v-input) {
    padding: 0px;
}
.nav-custom{
    color: gray;
}
/* .nav-custom:focus {
    background-color: #22a9bf;
    color: #fff;
} */
:deep(.v-text-field .v-input__details) {
    padding-inline: 1px;
    background-color: #f1f1f1 !important;
}
:deep(.fop .v-input .v-input__details){
    display: none;
}
.form-input {
    border: none !important;
}
.form-wrap + .form-wrap {
    margin-top: 15px;
}
.rd-form * + .button {
    margin-top: 15px;
}
.neew {
  background-color: #22a9bf;
  color: white;
}
.neew1
{
    background-color: #22a9bf;
    color: white;
}
.neew2
{
    background-color: #22a9bf;
    color: white;
    margin-bottom: 10px;
}
.fop
{
    display: flex;
    justify-content: space-between;
    margin-bottom: 0px;
}
.undel
{
    border-bottom: 1px solid #0d6efd;
}
.undel1
{
    border-bottom: 1px solid #0d6efd;
    margin-right: 10px;
}
.newp
{
    margin-top: 50px;
    margin-bottom: 30px;
}
:deep(.v-input--horizontal .v-input__append) {
    margin-inline-start: -35px !important;
}
:deep(.v-input__append)
{
    margin-right: 10px !important;
}
</style>
